import { FC, memo } from 'react'
import { Modal, Flex } from '@jisr-hr/design-system'
import { Typography } from '@jisr-hr/ds'
import i18n from 'translations/i18n'
import { ReactComponent as MudadImg } from 'containers/authorised/setting/v2/payroll/PaymentProcess/components/icons/mudad.svg'
import { useDispatch } from 'utils/hooks'
import { resetMudadState } from 'redux/setting/payrollManagement/paymentMethods/mudad/actionsCreator'
import { usePaymentMethod } from '../../components/usePaymentMethods'
import OwnerVerification from './OwnerVerification'
import Establishment from './Establishment'
import AuthorizePaymentAdmins from './AuthorizePaymentAdmins'
import VerifyPaymentAdmin from './VerifyPaymentAdmin'
import styles from './styles.module.css'

type propsType = {
  afterSubmit?: () => void
}

const MudadPaymentMethod: FC<propsType> = (props) => {
  const dispatch = useDispatch()
  const paymentCtx = usePaymentMethod()
  const { methodModalOpen, selectedPaymentMethod, setupModalOpen, mudadCurrentStep } = paymentCtx

  return (
    <Modal
      isOpen={methodModalOpen === 'mudad'}
      onClose={(): void => {
        // ? @note incase the setup modal open we don't need to reset the current payment
        const data = setupModalOpen ? selectedPaymentMethod : null
        paymentCtx.handleMethodModalOpen(data, null)
        paymentCtx.setCurrentSignatory(null)
        paymentCtx.setCurrentAuthorizer(null)
        dispatch(resetMudadState())
      }}
      variant="centerDialog"
      modalPaperClassName={styles.modal_paper_box}
      width={1100}
      height="90vh"
      modalHeaderStyle={{ background: '#fff', padding: '24px 24px 16px', minHeight: 'auto' }}
      header={
        <Flex
          itemsCenter
          style={{ gap: 8 }}
        >
          <MudadImg style={{ width: 32, height: 32 }} />
          <Typography
            variant="subtitle-1"
            style={{ lineHeight: '20px', color: 'var( --color-base-colors-grey-1000)' }}
            text={i18n.t('setup_mudad')}
          />
        </Flex>
      }
      content={
        <>
          {mudadCurrentStep === 1 && <Establishment />}
          {mudadCurrentStep === 2 && <OwnerVerification />}
          {mudadCurrentStep === 3 && <VerifyPaymentAdmin />}
          {mudadCurrentStep === 4 && <AuthorizePaymentAdmins afterSubmit={props.afterSubmit} />}
        </>
      }
    />
  )
}

export default memo(MudadPaymentMethod)
